import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pagination justify-content-center" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", _ctx.isInFirstPage === true ? 'disabled' : ''])
      }, [
        _createElementVNode("button", {
          class: "previous page-link",
          "aria-label": "Previous",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickPreviousPage && _ctx.onClickPreviousPage(...args)))
        }, " « ")
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
        return (_openBlock(), _createElementBlock("li", {
          key: page,
          class: _normalizeClass(["page-item", page.isDisabled === true ? 'active' : ''])
        }, [
          _createElementVNode("a", {
            class: "pageBtn page-link",
            onClick: ($event: any) => (_ctx.onClickPage(page.pageNum))
          }, _toDisplayString(page.pageNum), 9, _hoisted_2)
        ], 2))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", _ctx.isInLastPage === true ? 'disabled' : ''])
      }, [
        _createElementVNode("button", {
          class: "next page-link",
          "aria-label": "Next",
          type: "button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickNextPage && _ctx.onClickNextPage(...args)))
        }, " » ")
      ], 2)
    ])
  ]))
}